import React from 'react';
import { graphql, compose } from 'react-apollo';
import { List, Button, Input, Modal, Select } from 'antd/lib';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import getModelosNotasFiltradas from '../../graphql/querys/editor/getModelosNotasFiltradas';
import deleteModeloNota from '../../graphql/mutations/editor/deleteModeloNota';

import getOrganismos from '../../graphql/querys/organismos/getOrganismos.graphql';

import 'antd/lib/list/style';
import 'antd/lib/button/style';
import { errorService } from '../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(deleteModeloNota),
  graphql(getModelosNotasFiltradas, {
    options: () => {
      return { variables: { filtro: '' } };
    },
  }),
  graphql(getOrganismos, {
    name: 'getOrganismos',
  })
)
class ListarModelosNotas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingMore: false,
      showLoadingMore: true,
      data: [],
      filtro: '',
      organismoSeleccionado: null,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    // console.log("DIDMOUNT")
    let { filtro } = this.state;
    this.props.data.refetch({ filtro });
    this.setState(
      {
        loading: false,
        data: this.props.data.getModelosNotasFiltradas,
      },
      function() {
        this.ordenarLista();
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.data.getModelosNotasFiltradas !=
      nextProps.data.getModelosNotasFiltradas
    ) {
      this.setState(
        {
          loading: false,
          data: nextProps.data.getModelosNotasFiltradas,
        },
        () => {
          this.ordenarLista();
        }
      );
    }
  }

  handleChange = value => {
    // console.log(`selected ${value}`);
    this.setState(
      {
        ...this.state,
        organismoSeleccionado: value,
      },
      function() {
        this.filtrarOrganismo(value);
      }
    );
  };

  ordenarLista = () => {
    let listaOrdenada = _.orderBy(
      this.state.data,
      [
        modelo => {
          return modelo.titulo;
        },
      ],
      ['asc']
    );

    this.setState({
      ...this.state,
      data: listaOrdenada,
    });
  };

  filtrarOrganismo = async idOrganismo => {
    this.setState({
      ...this.state,
      loading: true,
    });

    let lista = [...this.props.data.getModelosNotasFiltradas];

    let listaFiltrada = _.filter(lista, modelo => {
      return _.some(modelo.organismos, { _id: idOrganismo });
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        data: listaFiltrada,
      },
      function() {
        this.ordenarLista();
      }
    );
  };

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    const { filtro } = this.state;
    this.setState({ loading: true });
    this.props.data.refetch({ filtro }).then(() => {
      this.setState({ loading: false });
    });
  };

  onDelete(id) {
    //Metodo encargado de ejecutar el llamado a GraphQL para determinar un modelo con id: id

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este modelo de nota?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        const { filtro } = yo.state;
        yo.setState({ loading: true });
        yo.props
          .mutate({
            refetchQueries: [
              {
                query: getModelosNotasFiltradas,
                variables: { filtro },
              },
            ],
            variables: {
              idModeloNota: id,
            },
          })
          .then(() => {
            yo.setState({ loading: false });
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar el modelo de nota'
            );
            console.log(err);
            errorService(err, {
              idModeloNota: id,
            });
            Modal.error({
              title: 'Error en la eliminacion del modelo de nota',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    const { loading, data } = this.state;

    const Search = Input.Search;

    const organismos = this.props.getOrganismos.getOrganismos;

    const { usuario } = this.props;
    return (
      <div>
        <Search
          placeholder="Ingrese el titulo de la nota para buscarlo"
          enterButton="Buscar"
          onChange={e => this.setState({ filtro: e.target.value })}
          onSearch={() => this._executeSearch()}
          size="large"
          style={{ margin: 10, width: '96.5%' }}
        />

        <div style={{ marginLeft: '1%' }}>
          <b>Filtrar por Organismo:</b>
          <Select
            showSearch
            style={{ width: 720, marginLeft: '1%' }}
            placeholder="Elegir organismo"
            optionFilterProp="children"
            value={this.state.organismoSeleccionado}
            onChange={this.handleChange}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {organismos &&
              organismos.map(organismo => (
                <Select.Option key={organismo._id}>
                  {organismo.nombre}
                </Select.Option>
              ))}
          </Select>
          <Button
            style={{ marginLeft: 10 }}
            onClick={() =>
              this.setState({
                ...this.state,
                organismoSeleccionado: null,
                data: this.props.data.getModelosNotasFiltradas,
              })
            }
          >
            {' '}
            Reiniciar Organismo{' '}
          </Button>
        </div>

        <List
          className="demo-loadmore-list"
          loading={loading}
          itemLayout="horizontal"
          dataSource={data}
          pagination={{
            onChange: page => {
              // console.log(page);
            },
            showSizeChanger: false,
            pageSize: 10,
          }}
          renderItem={item => (
            <List.Item
              style={{ marginInline: 15, padding: 10 }}
              actions={[
                <Button
                  key={`editar_${item._id}`}
                  disabled={usuario.rol != 'SUPERVISOR'}
                  onClick={() =>
                    this.props.history.push(`/admin/editor/${item._id}`)
                  }
                >
                  Editar
                </Button>,
                <Button
                  key={`eliminar${item._id}`}
                  disabled={usuario.rol != 'SUPERVISOR'}
                  type="danger"
                  onClick={() => this.onDelete(item._id)}
                >
                  Eliminar
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={
                  <Link to={`/admin/editor/${item._id}`}>
                    <h3>{item.titulo}</h3>
                  </Link>
                }
                description={<h4>{item.descripcion}</h4>}
              />
              {/* <div><p> Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido usó una galería de textos y los mezcló de tal manera que logró hacer un libro de textos especimen. No sólo sobrevivió 500 años, sino que tambien ingresó como texto de relleno en documentos electrónicos, quedando esencialmente igual al original. Fue popularizado en los 60s con la creación de las hojas "Letraset", las cuales contenian pasajes de Lorem Ipsum, y más recientemente con software de autoedición, como por ejemplo Aldus PageMaker, el cual incluye versiones de Lorem Ipsum.</p></div> */}
            </List.Item>
          )}
        />
      </div>
    );
  }
}
// export default graphql(getModelosNotasFiltradas)(ListarModelosNotas)
export default ListarModelosNotas;
